function Logout() {
    window.location.href = '/';
    return <div />;
}

export default Logout;
